/* eslint no-console: off */
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { Col, Row } from 'reactstrap';
import { useCallback, useEffect, useState } from 'react';
import { FaSpinner } from 'react-icons/fa';
import { yupResolver } from '@hookform/resolvers/yup';
import styles from './BookingFormContact.module.scss';
import useMedia from '../../../hook/useMedia';
import Vip29ApiService from '../../../services/Vip29ApiService';
import ToastMessage from '../Toast';
import InputContact from '../InputContact';

const BookingSchema = yup.object().shape({
    first_name: yup.string().required('Required First Name'),
    sur_name: yup.string().required('Required Surname'),
    email: yup.string(),
    phone_number: yup.string(),
    message: yup.string().required('Required Message')
});

const BookingFormContact = (props) => {
    const isMd = useMedia('(min-width: 768px)');

    const [errorPhone, setErrorPhone] = useState({
        phone_number: false,
    });
    const [errorEmail, setErrorEmail] = useState({
        email: false,
    });
    const [formStore, setFormStore] = useState({
        first_name: '',
        sur_name: '',
        email: '',
        phone_number: '',
        message: '',
        lat: '',
        lng: '',
        address: ''
    })
    const [btnLoading, setBtnLoadding] = useState(false)
    const [validError, setValidError] = useState(false)

    const formDefault = () => {
        setFormStore({
            first_name: '',
            sur_name: '',
            email: '',
            phone_number: '',
            message: '',
            lat: '',
            lng: '',
            address: ''
        })
    }

    const regexEmail = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/

    const notify = useCallback((type, message) => {
        ToastMessage({ type, message });
        return null;
    }, []);

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm({
        defaultValues: {
            booking_format: 'pick_up',
        },
        resolver: yupResolver(BookingSchema),
    });

    const validateEmailAndPhone = (val) => {
        const { email, phone_number } = val;
        const PHONE_MIN_LENGTH = 10;
        const valid =
            phone_number === null
                ? true
                : phone_number.length < PHONE_MIN_LENGTH;
        if (email.length === 0 && valid) {
            setErrorEmail((d) => ({
                email: true,
            }));
            setErrorPhone((d) => ({
                phone_number: valid,
            }));
            setValidError(false)
        } else if (!regexEmail.test(email)) {
            setValidError(true)
            setErrorEmail((d) => ({
                email: true,
            }));
            setErrorPhone((d) => ({
                phone_number: valid,
            }));
        } else {
            setErrorEmail((d) => ({
                email: false,
            }));
            setErrorPhone((d) => ({
                phone_number: false,
            }));
            setValidError(false)
        }
    };


    const validatePhoneValue = (val) => {
        const { phone_number } = val;
        const PHONE_MIN_LENGTH = 10;
        const valid =
            phone_number === null
                ? true
                : phone_number.length < PHONE_MIN_LENGTH;
        setErrorPhone((d) => ({
            phone_number: valid,
        }));
    };

    const validateIntiValue = (val) => {
        validateEmailAndPhone(val)
    };

    const onSubmit = async (data) => {
        if ((formStore.email.length !== 0 && regexEmail.test(formStore.email)) || formStore.phone_number) {
            try {
                setBtnLoadding(true)
                await Vip29ApiService.sendContact(formStore);
                notify('success', 'Booking Complete');
                formDefault()
                reset({
                    first_name: '',
                    sur_name: '',
                    email: '',
                    phone_number: '',
                    message: '',
                    lat: '',
                    lng: '',
                    address: ''
                })
                setBtnLoadding(false)
            } catch (e) {
                notify('error', e?.message || 'Error');
                setBtnLoadding(false)
            }
        }
    };

    const onChange = (name, value) => {
        if (['email'].includes(name)) {
            if (value.length > 0) {
                setFormStore({
                    ...formStore,
                    [name]: value
                })
                setErrorEmail({
                    email: false
                })
            } else {
                setErrorEmail({
                    email: true
                })
            }
        }
        if (['phone_number'].includes(name)) {
            setFormStore({
                ...formStore,
                [name]: value.val,
                phone_number_format: `+${value.val}`,
                phone_dial_code: value.data.dialCode,
                phone_country_code: value.data.countryCode,
            });
            validatePhoneValue({ ...formStore, [name]: value.val });
        } else {
            setFormStore({
                ...formStore,
                [name]: value,
            })
        }
    };

    const validateForm = () => {
        validateIntiValue(formStore);
    };

    useEffect(() => {
        setFormStore({
            ...formStore,
            lat: props.address?.val?.lat,
            lng: props.address?.val?.lng,
            address: props.address?.val?.address
        })
    }, [props.address?.val])

    return (
        <div
            className={styles.BookingFormContac}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                    <Col xs="12" md="6">
                        <div className={styles.formGroup}>
                            <InputContact
                                required={false}
                                label="First Name*"
                                errors={errors}
                                register={register('first_name', {
                                    onChange: (e) => {
                                        onChange(
                                            e.target.name,
                                            e.target.value
                                        );
                                    },
                                })}
                            />
                        </div>
                    </Col>
                    <Col xs="12" md="6">
                        <div className={styles.formGroup}>
                            <InputContact
                                required={false}
                                label="Surname"
                                errors={errors}
                                register={register('sur_name', {
                                    onChange: (e) => {
                                        onChange(
                                            e.target.name,
                                            e.target.value
                                        );
                                    },
                                })}
                            />
                        </div>
                    </Col>
                    <Col xs="12" md="6">
                        <div className={styles.formGroup}>
                            <InputContact
                                type="email"
                                required={false}
                                label="Email"
                                validError={validError}
                                errors={errorEmail}
                                register={register('email', {
                                    onChange: (e) => {
                                        onChange(
                                            e.target.name,
                                            e.target.value
                                        );
                                    },
                                })}
                            />
                        </div>
                    </Col>
                    <Col xs="12" md="6">
                        <div className={styles.formGroup}>
                            <InputContact
                                type="phone"
                                required={false}
                                label="Phone Number"
                                errors={errorPhone}
                                onChange={onChange}
                                register={register('phone_number')}
                                defaultValue={formStore.phone_number}
                            />
                        </div>
                    </Col>
                    <Col xs="12" md="12">
                        <div className={styles.formGroup}>
                            <InputContact
                                required={false}
                                label="Message"
                                errors={errors}
                                register={register('message', {
                                    onChange: (e) => {
                                        onChange(
                                            e.target.name,
                                            e.target.value
                                        );
                                    },
                                })}
                            />
                        </div>
                    </Col>
                </Row>
                <div className={styles.btnWrapper}>
                    <button
                        className={btnLoading ? styles.bookingBtnLoading : styles.bookingBtn}
                        type="submit"
                        onClick={validateForm}
                    >
                        {btnLoading ? <FaSpinner className={styles.loadingIcon} /> : 'SUBMIT'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default BookingFormContact;
